import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    CCard,
    CCardBody,
    CCardHeader,
    CCol,
    CRow,
    CCardFooter,
    CButton,
    CLink,
    CDropdown,
    CDropdownToggle,
    CDropdownMenu,
    CDropdownItem,
    CTooltip,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { ThePermission } from '../ThePermission';
import DocsCategories from 'src/views/docs/DocsCategories';
import DocCategoriesForm from 'src/views/docs/DocCategoriesForm';
import { docActions, userActions } from 'src/_actions';
import { helps } from 'src/_helpers';

class DocsCategoriesContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modals: [],
            page_header: 'Nhóm Văn Bản',
        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    componentDidMount() {

        if (helps.isEmpty(this.props.users)) {
            this.props.getUsers();
        }

        this.props.getAllCat();
    }

    handleSubmit(category) {
        if (helps.isEmpty(category.id)) {
            this.props.addCat(category);
            this.toggleModal('add');
        } else {
            this.props.updateCat(category);
            this.toggleModal(category.id);
        }
    }

    toggleModal = (item) => {
        let modals = this.state.modals;
        const position = modals.indexOf(item);
        let newItems = modals.slice();
        if (position !== -1) {
            newItems.splice(position, 1)
        } else {
            newItems = [...modals, item]
        }
        this.setState({ modals: newItems });
        console.log(item)
    }

    render() {
        return (
            <ThePermission {... this.props} component="docs" action="view" alertOut={true}>
                <CRow key={helps.convertToSlug(this.state.page_header)}>
                    <CCol xl={12}>
                        <CCard>
                            <CCardHeader>
                                <CRow>
                                    <CCol>
                                        {this.state.page_header}
                                    </CCol>
                                    <CCol className={'text-right'}>
                                        <CButton type="button" color="primary" size="sm" onClick={() => { this.toggleModal('add') }}>
                                            <CIcon name="cil-plus" className="mfe-1 mt-0"></CIcon>
                                            Thêm Nhóm Văn Bản
                                        </CButton>

                                        <CDropdown tag={'span'} className='mr-1 ml-1'>
                                            <CTooltip content='Tham khảo'>
                                                <CDropdownToggle caret color="secondary" size='sm'>
                                                    <CIcon color='warning' name="cil-lightbulb" style={{ cursor: 'help', color: 'orange' }} />
                                                    Tham khảo
                                                </CDropdownToggle>
                                            </CTooltip>
                                            <CDropdownMenu className="pt-0" placement="bottom-end">
                                                <CDropdownItem header>
                                                    <CLink href='https://datafiles.chinhphu.vn/cpp/files/vbpq/2020/03/30.signed.pdf' target='_blank' className={'h6'} title='Nghị định số 30/2020/NĐ-CP của Chính phủ: Về công tác Văn Bản'>
                                                        <CIcon name="cil-link" className="mfe-1 mt-0"></CIcon>
                                                        Nghị định 30/2020/NĐ-CP
                                                    </CLink>
                                                </CDropdownItem>
                                                <CDropdownItem header>
                                                    <CLink href='https://thuvienphapluat.vn/chinh-sach-phap-luat-moi/vn/ho-tro-phap-luat/tu-van-phap-luat/30698/cach-ghi-so-hieu-van-ban-hanh-chinh-dung-chuan-phap-luat' target='_blank' className={'h6'} title='Cách ghi số hiệu văn bản hành chính đúng chuẩn'>
                                                        <CIcon name="cil-link" className="mfe-1 mt-0"></CIcon>
                                                        Cách ghi số hiệu văn bản hành chính
                                                    </CLink>
                                                </CDropdownItem>
                                            </CDropdownMenu>
                                        </CDropdown>
                                    </CCol>
                                </CRow>
                            </CCardHeader>
                            <CCardBody className='docs-table'>
                                <DocsCategories {... this.props} toggleModal={this.toggleModal} handleSubmit={this.handleSubmit} modals={this.state.modals} />
                                <DocCategoriesForm
                                    {... this.props}
                                    modals={this.state.modals}
                                    form_header="Thêm Nhóm Văn Bản"
                                    item='add'
                                    toggleModal={() => { this.toggleModal('add') }}
                                    handleSubmit={this.handleSubmit}
                                />
                            </CCardBody >
                            <CCardFooter>
                                Tổng: <b>{this.props.docs && <>{this.props.docs.length}</>}</b>
                            </CCardFooter>
                        </CCard >
                    </CCol >
                </CRow >
            </ThePermission>
        );
    }
}

function mapStateToProps(state) {
    const { loading_cat, categories } = state.docsReducer;
    const { users } = state.userReducer;
    const { user } = state.authentication;
    return { loading_cat, categories, users, user };
}

const actionCreators = {
    getAllCat: docActions.getAllCat,
    addCat: docActions.addCat,
    updateCat: docActions.updateCat,
    updateFieldCat: docActions.updateFieldCat,
    getUsers: userActions.getAll,
};

const connectedContainer = connect(mapStateToProps, actionCreators)(DocsCategoriesContainer);
export { connectedContainer as DocsCategoriesContainer };